<template>
  <div id="app">
    <app-activity/>
  </div>
</template>

<script>
import AppActivity from "@/views/activities/app/app.activity"
export default {
  name: "App",
  components:{
    AppActivity
  }
};
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  position: relative;
  margin: 0;
  padding: 0;
  background: #343541;
  height: 100%;
  width: 100vw;
}
</style>
